import gql from 'graphql-tag';

const queryGenerateGooglePass = gql`
	query GenerateGooglePass($membershipID: String!) {
		generateGooglePass(membershipID: $membershipID)
	}

`;

export default queryGenerateGooglePass;